/**
 * Форматирует номер телефона в вид +7 XXX XXX-XX-XX.
 * Синхронно с be/src/common/format-phone.ts
 */
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return '';

  const digits = phone.replace(/\D/g, '');
  const normalized = digits.startsWith('8') ? '7' + digits.slice(1) : digits;
  const withCountryCode = normalized.startsWith('7')
    ? normalized
    : '7' + normalized;

  if (withCountryCode.length !== 11) {
    return phone;
  }

  const code = withCountryCode.slice(1, 4);
  const part1 = withCountryCode.slice(4, 7);
  const part2 = withCountryCode.slice(7, 9);
  const part3 = withCountryCode.slice(9, 11);

  return `+7 ${code} ${part1}-${part2}-${part3}`;
}
